import React from 'react'
import Layout from '../Layout'

export default function PrivacyPolicy(props) {
    return (
        <Layout props={props}>
            <div className="px-5 py-4 staticPgWrapper">
                <span
                    dangerouslySetInnerHTML={{
                        __html: global.storeDetails.privacy_policy,
                    }}
                />
            </div>
        </Layout>
    )
}
